import SubHome from "../components/SubHome";
import "../styles/components/faq.css";
import Accordion from "../components/Accordion";
import Footer from "../components/Footer";

function FAQSP() {
  const faqsEater = [
    {
      question: "¿Cómo funciona la app?",
      answer:
        "La app te permite publicar una oferta para que un cocinero profesional venga a tu casa a preparar una comida, unos tuppers o una gran velada. Simplemente selecciona el tipo de comida que deseas, para cuantas personas, cuantos días, elige una fecha y hora, y publica la oferta. Un cocinero cercano aceptará la oferta y se dirigirá a tu casa.",
    },
    {
      question:
        "¿Puedo ver en dónde se encuentra el cocinero antes de que llegue?",
      answer:
        "Sí, una vez que un cocinero ha aceptado tu oferta, podrás ver su ubicación en tiempo real en el mapa de la app. Esto te permite saber exactamente cuánto tiempo le queda para llegar a tu domicilio.",
    },
    {
      question: "¿Cómo selecciono el tipo de comida que quiero?",
      answer:
        "Puedes especificar el tipo de cocina (italiana, mexicana, vegetariana, etc.), los platos específicos o cualquier restricción dietética que tengas. También puedes agregar notas adicionales para personalizar tu solicitud.",
    },
    {
      question: "¿Qué incluye el servicio del cocinero?",
      answer:
        "El servicio incluye la preparación de la comida en tu casa, el emplatado. Por un extra de 2 euros la limpieza básica de la cocina después de cocinar.",
    },
    {
      question: "¿Quién proporciona los ingredientes?",
      answer: "El eater proporciona los ingredientes.",
    },
    {
      question: "¿Cómo se calculan los precios?",
      answer:
        "Los precios varían según el tipo de comida, la complejidad de la preparación, y la experiencia del cocinero. El costo final se mostrará antes de que publiques tu oferta.",
    },
    {
      question: "¿Puedo elegir un cocinero en particular?",
      answer:
        "No, los cocineros aceptan las ofertas según su disponibilidad. Sin embargo, puedes calificar a los cocineros después de cada servicio, lo que ayudará a otros usuarios a elegir los mejores.",
    },
    {
      question: "¿Qué pasa si el cocinero no llega a tiempo?",
      answer:
        "Si el cocinero no llega en el horario acordado, puedes comunicarte con el soporte de la app para resolver el problema. Dependiendo de la situación, se te podría ofrecer un reembolso o un descuento en tu próximo servicio.",
    },
    {
      question: "¿Cómo puedo pagar el servicio?",
      answer:
        "Todos los pagos se realizan a través de la app mediante tarjeta de crédito, débito u otros métodos de pago electrónicos. El pago se procesa automáticamente una vez que el servicio se ha completado satisfactoriamente.",
    },
    {
      question: "¿Qué debo hacer si no estoy satisfecho con el servicio?",
      answer:
        "Si el servicio no cumplió con tus expectativas, puedes dejar una reseña y calificación en la app. Además, puedes contactar al servicio de atención al cliente para resolver cualquier problema y, si es necesario, solicitar un reembolso parcial o total.",
    },
    {
      question: "¿Puedo cancelar mi oferta después de publicarla?",
      answer:
        "Sí, puedes cancelar tu oferta, pero dependiendo del tiempo de antelación con que lo hagas, podría aplicarse una penalización.",
    },
    {
      question: "¿Qué es Cheffy?",
      answer:
        "Cheffy es una aplicación que conecta a personas les gusta cocinar, con aquellas que no disfrutan cocinando, están cansadas de comer siempre lo mismo, no tienen tiempo o simplemente quieren experimentar con la cultura culinaria. La misión de Cheffy es encontrar el Chef perfecto para aquellas personas que no quieren cocinar. Pueden pedir el plato que quieran, en el momento que quieran y un 'Cooker' lo hará por ellos. En su cocina y con sus ingredientes.",
    },
    {
      question: "¿Cómo funciona el modelo de monetización?",
      answer:
        "El modelo de monetización de Cheffy se basa en una comisión del 10% sobre el precio final de cada servicio. Es decir, si un cliente paga 10 euros por un servicio, el 'cooker' recibirá 9 euros y la empresa (Cheffy) recibirá 1 euro. Esta estructura permite a la compañía obtener una fuente de ingresos estable y predecible, al tiempo que ofrece un incentivo justo para los 'cookers' que ofrecen sus servicios a través de la plataforma. Además, la plataforma se integra con Stripe, una plataforma de pagos segura y confiable, lo que garantiza que los pagos se procesen sin problemas y sin interrupciones.",
    },
    {
      question: "¿Cómo es la seguridad ante el 'Cooker'?",
      answer:
        "Cheffy implementa un proceso de 'conoce a tu cliente' para garantizar la seguridad de los usuarios. Los cocineros que desean trabajar en la plataforma deben proporcionar una foto de su DNI o pasaporte, lo que permite una verificación adecuada de su identidad. De esta manera, se evita que se registren personas no autorizadas en la plataforma.",
    },
    {
      question: "¿Existe política de privacidad?",
      answer:
        "Otro aspecto importante de la protección de datos es la política de privacidad de la empresa. Los términos y condiciones y las políticas de privacidad de la plataforma están disponibles para los usuarios, lo que garantiza que los datos personales se manejen adecuadamente y se protejan de acuerdo con la legislación vigente. Los usuarios pueden estar seguros de que sus datos personales se manejan de manera confidencial y se protegen contra el acceso no autorizado.",
    },
  ];
  const faqsCooker = [
    {
      question: "¿Cómo puedo registrarme como cocinero en la app?",
      answer:
        "Para registrarte, simplemente descarga la app y completa el formulario de inscripción. Deberás proporcionar información sobre tu experiencia, especialidades culinarias, y cargar los documentos necesarios para verificar tu identidad y cualificaciones.",
    },
    {
      question:
        "¿Cómo encuentro la dirección del eater y cuánto me tomará llegar?",
      answer:
        "Después de aceptar una oferta, la dirección del eater aparecerá en tu pantalla junto con un mapa que muestra la ruta más rápida para llegar. También puedes ver el tiempo estimado de llegada para que el eater pueda seguir tu progreso en tiempo real.",
    },
    {
      question: "¿Cómo acepto una oferta?",
      answer:
        "Las ofertas aparecerán en tu pantalla según tu ubicación y disponibilidad. Puedes revisar los detalles de cada oferta y aceptarla si se ajusta a tus preferencias y horario.",
    },
    {
      question: "¿Cómo se determina mi tarifa?",
      answer:
        "La tarifa se calcula en función de varios factores, como la complejidad del menú, la duración del servicio. La app te mostrará el precio de la oferta final antes de aceptar una oferta.",
    },
    {
      question:
        "¿Qué debo hacer si no puedo asistir a una oferta que he aceptado?",
      answer:
        "Si por alguna razón no puedes asistir a una oferta que ya has aceptado, debes cancelarla lo antes posible a través de la app. Repetidas cancelaciones podrían afectar tu calificación en la plataforma.",
    },
    {
      question:
        "¿Qué sucede si los ingredientes no están disponibles o son insuficientes?",
      answer:
        "Si los ingredientes no están disponibles o son insuficientes, debes comunicarte inmediatamente con el eater para buscar una solución.",
    },
    {
      question: "¿Tengo que limpiar la cocina después de cocinar?",
      answer:
        "No como parte del servicio, solo si el “eater” paga el servicio extra de dos euros se espera que dejes la cocina en las mismas condiciones en que la encontraste.",
    },
    {
      question: "¿Cómo y cuándo recibiré mi pago?",
      answer:
        "Recibirás tu pago automáticamente a través de la app una vez que el servicio haya sido completado y el eater lo haya confirmado. El pago se transferirá a tu cuenta bancaria en un plazo determinado (generalmente entre 1 y 3 días hábiles).",
    },
    {
      question: "¿Puedo rechazar una oferta después de verla?",
      answer:
        "Sí, puedes rechazar cualquier oferta que no se ajuste a tus preferencias o disponibilidad. No estás obligado a aceptar todas las ofertas que te lleguen.",
    },
    {
      question: "¿Cómo afectan las calificaciones y reseñas a mi perfil?",
      answer:
        "Las calificaciones y reseñas de los eaters afectan tu reputación en la plataforma. Mantener una alta calificación te ayudará a recibir más ofertas y posiblemente tarifas más altas.",
    },
    {
      question: "¿Qué pasa si tengo un conflicto con un eater?",
      answer:
        "Si surge algún conflicto con un eater durante o después del servicio, puedes reportarlo a través de la app. El equipo de soporte intervendrá para ayudar a resolver el problema de manera justa para ambas partes.",
    },
  ];

  return (
    <>
      <SubHome
        mainHeading="
Preguntas frecuentes"
        listItem="
Preguntas frecuentes"
      />
      <div className="faq-box">
        <div className="heading-content-section" style={{ marginTop: "60px" }}>
          <h2 className="main-heading">Para los Usuarios (Eaters)</h2>
          <div
            className="heading-border"
            style={{ marginBottom: "40px" }}
          ></div>
        </div>
        <div className="accordion" style={{ width: "100%" }}>
          {faqsEater.map((item, index) => (
            <Accordion
              key={index}
              title={item.question}
              description={item.answer}
            />
          ))}
        </div>
        <div className="heading-content-section" style={{ marginTop: "60px" }}>
          <h2 className="main-heading">Para los Cocineros (Cookers)</h2>
          <div
            className="heading-border"
            style={{ marginBottom: "40px" }}
          ></div>
        </div>
        <div className="accordion acc2" style={{ width: "100%" }}>
          {faqsCooker.map((item, index) => (
            <Accordion
              key={index}
              title={item.question}
              description={item.answer}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export default FAQSP;
